
export function formatLocation(values) {
    if (isAnyNull(values)) {
        return '';
    }
    if (!values.accuracy) {
        return values.y + ', ' + values.x;
    }
    return values.y + ', ' + values.x + ' ~' + Math.round(values.accuracy) + 'm';
}

export function isAnyNull(values) {
    return !values || !values.x || !values.y || !values.epsgCode;
}